import { render, staticRenderFns } from "./AppList.vue?vue&type=template&id=15cd42e0&scoped=true&lang=pug&"
import script from "./AppList.vue?vue&type=script&lang=js&"
export * from "./AppList.vue?vue&type=script&lang=js&"
import style0 from "./AppList.vue?vue&type=style&index=0&id=15cd42e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cd42e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VDivider,VIcon,VList,VListItem,VProgressCircular})
